<template>
  <div class="d-flex flex-column" v-if="lazyLoad">
    <div class="d-flex flex-row">
      <span class="badge badge-light mt-auto mb-auto mr-2">{{ lineIndex + nodeData.seq }}</span>
      <div class="text-style">{{ nodeData.name }}</div>
      <input-for-inspect-template v-if="nodeData.format!==undefined"
                                  :readonly="readonly"
                                  :format="nodeData.format"
                                  :value.sync="multiTemplateData[nodeData.id + '**' + nodeData.seq].value"></input-for-inspect-template>
    </div>
    <div class="ml-2">
      <div v-if="nodeData.type===1">
        <QualityInspectTemplate
            v-for="child in nodeData.childNodes"
            :key="child.id"
            :ref="child.id"
            :readonly="readonly"
            :line-index="lineIndex + nodeData.seq + '.'"
            :node-data="child"></QualityInspectTemplate>
      </div>
      <div v-else-if="nodeData.type===2">
        <table class="table table-bordered mr-2">
          <thead class="thead-light">
          <tr>
            <th>
              <div v-if="maxColumnRows > 0 || readonly">#</div>
              <button v-else type="button" class="btn btn-outline-success" @click="newRow">#</button>
            </th>
            <th v-for="column in nodeData.childNodes" :key="column.id">
              <div class="text-style">{{ column.name }}</div>
            </th>
          </tr>
          </thead>
          <tbody>
          <template v-if="maxColumnRows > 0">
            <tr v-for="index in maxColumnRows" :key="index">
              <th>{{ index }}</th>
              <td v-for="column in nodeData.childNodes" :key="index + column.id" class="text-style">
                <div
                    v-if="column.format === undefined && findSeq(column, index) != null && findSeq(column, index).format === undefined">
                  {{ findSeq(column, index).name }}
                </div>
                <input-for-inspect-template v-else-if="column.format !== undefined"
                                            :readonly="readonly"
                                            :format="column.format"
                                            :value.sync="multiTemplateData[column.id + '**' + index].value"></input-for-inspect-template>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr v-for="index in rowIndex" :key="index">
              <th>
                <div v-if="readonly">{{ index }}</div>
                <button v-else type="button" class="btn btn-outline-danger" @click="deleteRow(index)">
                  {{ index }}
                </button>
              </th>
              <td v-for="column in nodeData.childNodes" :key="index + column.id" class="text-style">
                <input-for-inspect-template v-if="column.format !== undefined"
                                            :readonly="readonly"
                                            :format="column.format"
                                            :value.sync="multiTemplateData[column.id + '**' + index].value"></input-for-inspect-template>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import InputForInspectTemplate from "@/views/sithMes/quality/inspectTemplate/cells/InputForInspectTemplate";

export default {
  name: "QualityInspectTemplate",
  components: {InputForInspectTemplate},
  props: {
    nodeData: {
      type: Object,
      required: true
    },
    lineIndex: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      templateData: {},
      lazyLoad: false,
      rowIndex: 0
    }
  },
  computed: {
    maxColumnRows() {
      let temp = 0;
      for (let item of this.nodeData.childNodes) {
        if (item.childNodes !== undefined && item.childNodes instanceof Array) {
          for (let node of item.childNodes) {
            if (node.seq > temp) {
              temp = node.seq;
            }
          }
        }
      }
      return temp;
    },
    taskId() {
      if (this.$route.query.hasOwnProperty('taskId')) {
        return this.$route.query.taskId;
      }
      return null;
    },
    templateRootId() {
      if (this.$route.query.hasOwnProperty('templateId')) {
        return this.$route.query.templateId;
      }
      return null;
    },
    multiTemplateData() {
      return this.readonly ? this.$route.params.templateData : this.templateData;
    }
  },
  mounted() {
    if (!this.readonly) {
      this.beforeLoad();
    } else {
      if (this.nodeData.type === 2 && this.maxColumnRows === 0) {
        console.log(this.nodeData)
        let tempReg = '';
        for (let item of this.nodeData.childNodes) {
          tempReg += item.id + '|';
        }
        let reg = new RegExp(tempReg + this.nodeData.id + '\\*\\*.*');
        console.log(reg)
        for (let id in this.multiTemplateData) {
          if (this.multiTemplateData.hasOwnProperty(id) && reg.test(id)) {
            let seq = Number.parseInt(id.substring(id.lastIndexOf('*') + 1, id.length));
            if (seq > this.rowIndex) {
              this.rowIndex = seq;
            }
          }
        }
      }
      this.lazyLoad = true;
    }
  },
  methods: {
    beforeLoad() {
      if (this.nodeData.format !== undefined) {
        this.templateData[this.nodeData.id + '**' + this.nodeData.seq] = this.cellStoreObject(this.nodeData);
      }
      if (this.nodeData.type === 2 && this.nodeData.hasOwnProperty('childNodes')) {
        for (let column of this.nodeData.childNodes) {
          if (column.format !== undefined) {
            for (let i = 1; i <= this.maxColumnRows; i++) {
              this.templateData[column.id + '**' + i] = this.cellStoreObject(column, i);
            }
          }
        }
      }
      this.lazyLoad = true;
    },
    findSeq(node, seq) {
      if (node.hasOwnProperty('childNodes') && node.childNodes instanceof Array) {
        for (let item of node.childNodes) {
          if (item.seq === seq) {
            return item;
          }
        }
      }
      return null;
    },
    newRow() {
      for (let column of this.nodeData.childNodes) {
        if (column.format !== undefined) {
          this.templateData[column.id + '**' + (this.rowIndex + 1)] = this.cellStoreObject(column, this.rowIndex + 1);
        }
      }
      this.rowIndex += 1;
    },
    deleteRow(index) {
      this.$confirm('确认删除行?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (let column of this.nodeData.childNodes) {
          if (column.format !== undefined) {
            for (let i = index; i < this.rowIndex; i++) {
              this.templateData[column.id + '**' + i] = this.templateData[column.id + '**' + (i + 1)];
            }
            delete this.templateData[column.id + '**' + this.rowIndex];
          }
        }
        this.rowIndex -= 1;
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      })
    },
    exportData() {
      let tempDataList = [];
      if (this.nodeData.type === 1 && this.nodeData.hasOwnProperty('childNodes')) {
        for (let item of this.nodeData.childNodes) {
          tempDataList.push.apply(tempDataList, this.$refs[item.id][0].exportData());
        }
      }
      for (let id in this.templateData) {
        tempDataList.push(this.templateData[id]);
      }
      return tempDataList;
    },
    reloadDefaultValue({format, defaultValue}) {
      if (defaultValue === undefined) {
        switch (format) {
          case 'String':
            return '';
          case 'Number':
            return 0;
          case 'Boolean':
            return false;
        }
      } else return defaultValue;
    },
    cellStoreObject(item, seq) {
      return {
        templateRootId: this.templateRootId,
        taskId: this.taskId,
        templateId: item.id,
        value: this.reloadDefaultValue(item),
        seq: seq === undefined ? item.seq : seq
      }
    }
  }
}
</script>

<style scoped>
.text-style {
  font-size: 1rem;
  font-weight: bold;
  padding: 2px;
}
</style>